import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const containerStyle = css`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(0, 2)};
  width: 100%;
  height: 100%;
  container-type: size;
  container-name: submission-details-side-panel;
`;

interface GetSidePanelStyleConfig {
  isMobileView: boolean;
}

export function getSidePanelStyle({ isMobileView }: GetSidePanelStyleConfig) {
  if (isMobileView) {
    return containerStyle;
  }

  return [
    containerStyle,
    css`
      border-left: 1px solid ${theme.colors.neutral20};
      max-width: 350px;
    `,
  ];
}
